import React, { useRef, useState, useEffect } from 'react';
import {
  Grid,
  Menu,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
  Icon,
  Input,
  Link,
  fabClasses,
} from '@mui/material';
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import MKInput from 'components/MKInput';
import MKTypography from "components/MKTypography";
import MKAlert from "components/MKAlert";
import profilePicture from "assets/images/bruce-mars.jpg";
import Profile from "pages/LandingPages/Author/sections/Profile";
import Posts from "pages/LandingPages/Author/sections/Posts";
import Contact from "pages/LandingPages/Author/sections/Contact";
import Footer from "pages/LandingPages/Author/sections/Footer";
import routes from "trainingCompanyEditRoutes";
import bgImage from "assets/images/trainer-profile.jpg";
import { useParams } from "react-router-dom";
import Logo from "assets/images/skill2.png";
import Breadcrumbs from "examples/Breadcrumbs";
import { LocationOn, AttachMoney, WindowSharp } from '@mui/icons-material';
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Modal from "@mui/material/Modal";
import DatePicker from "react-multi-date-picker";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import FormControl from '@mui/material/FormControl';
import { useNavigate } from 'react-router-dom';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import AWS from 'aws-sdk';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "40px" }} onClick={openCalendar}>Select Dates</MKButton>
    </div>
  )
}

function Author() {
  //   const styles = {
  //     gridItem: {
  //         border: '1px double #ccc',
  //         borderRadius: '30px',
  //         padding: '16px',
  //         marginBottom: '16px',
  //         boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  //         width: '500px',
  //         backgroundColor: ({ palette: { white }, functions: { rgba } }) =>rgba(white.main, 1.0),backdropFilter: "saturate(200%) blur(30px)",boxShadow: ({ boxShadows: { xxl } }) => xxl,
  //     },
  //     trainingInfo: {
  //         display: 'flex',
  //         flexDirection: 'column',
  //     },
  //     trainingName: {
  //         marginTop: '-10px',
  //         marginBottom: '8px',
  //         fontSize: 'medium',
  //         color : 'rgb(60, 150, 190)'
  //     },
  //     gridContent: {
  //         padding: '8px',
  //     },
  // };
  const { trainingID } = useParams();
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [appliedTrainerDetails, setAppliedTrainerDetails] = useState([]);
  const [trainerStatus12, setTrainerStatus12] = useState([]);
  const [trainerStatus20, setTrainerStatus20] = useState([]);
  const [trainerWithStatus6, setTrainerWithStatus6] = useState([]);
  const [trainerWithStatus7, setTrainerWithStatus7] = useState([]);
  const [trainerExceededPayment, setTrainerExceededPayment] = useState([]);
  const [trainerWithStatus9, setTrainerWithStatus9] = useState([]);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [trainingList, setTrainingList] = useState([]);
  const [submitRemainderCompleted, setSubmitRemainderCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [trainerDetails, setTrainerDetails] = useState([]);
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
  const [commercialsCurrency, setCommercialsCurrency] = useState("");
  const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
  const [commercials4hrs, setCommercials4hrs] = useState("");
  const [commercials8hrs, setCommercials8hrs] = useState("");
  const [lastDeliveredDate, setLastDeliveredDate] = useState("");
  const [lastClient, setLastClient] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
  const [callAvailableDate, setCallAvailableDate] = useState([]);
  const [trainingComment, settrainingComment] = useState("");
  const [userId, setUserId] = useState("");
  const [currency, setCurrency] = useState('');
  const [trainerProfile, setTrainerProfile] = useState("");
  const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
  const [selectedTraining, setSelectedTraining] = useState('');
  const [selectedTrainingName, setSelectedTrainingName] = useState("");
  const [selectedTrainingID, setSelectedTrainingID] = useState("");
  const [lab, setLab] = useState("");
  const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
  const [serverCount, setServerCount] = useState("");
  const [typeOfServer, setTypeOfServer] = useState("");
  const [submitCancelTraining, setSubmitCancelTraining] = useState(false);
  const [responseFromDB, setResponseFromDB] = useState("");
  const [maxRemainderCount, setMaxRemainderCount] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [trainingStartDate, setTrainingStartDate] = useState('');
  const [trainingEndDate, setTrainingEndDate] = useState('');
  const [finalizedCommercials, setFinalizedCommercials] = useState('');
  const [expectedPaymentDate, setExpectedPaymentDate] = useState('');
  const [expectedNewPaymentDate, setExpectedNewPaymentDate] = useState('');
  const [feedbackStatusAvailable, setFeedbackStatusAvailable] = useState(false);
  const [finalizedTrainingSchedule, setFinalizedTrainingSchedule] = useState('');
  const [finalizedTrainingTiming, setFinalizedTrainingTiming] = useState('');
  const [finalizedStartTime, setFinalizedStartTime] = useState('');
  const [finalizedEndTime, setFinalizedEndTime] = useState('');
  const [feedbackQuestions, setFeedbackQuestions] = useState([]);
  const [feedbackRating, setFeedbackRating] = useState(0);
  const [isFeedback1Interacted, setIsFeedback1Interacted] = useState(false);
  const [feedbackAnswer1, setFeedbackAnswer1] = useState("");
  const [isFeedback2Interacted, setIsFeedback2Interacted] = useState(false);
  const [feedbackAnswer2, setFeedbackAnswer2] = useState("");
  const [isFeedback3Interacted, setIsFeedback3Interacted] = useState(false);
  const [feedbackAnswer3, setFeedbackAnswer3] = useState("");
  const [isFeedback4Interacted, setIsFeedback4Interacted] = useState(false);
  const [feedbackAnswer4, setFeedbackAnswer4] = useState("");
  const [isFeedback5Interacted, setIsFeedback5Interacted] = useState(false);
  const [feedbackAnswer5, setFeedbackAnswer5] = useState("");
  const [isFeedback6Interacted, setIsFeedback6Interacted] = useState(false);
  const [feedbackAnswer6, setFeedbackAnswer6] = useState("");
  const [isFeedback7Interacted, setIsFeedback7Interacted] = useState(false);
  const [feedbackAnswer7, setFeedbackAnswer7] = useState("");
  const [isFeedback8Interacted, setIsFeedback8Interacted] = useState(false);
  const [feedbackAnswer8, setFeedbackAnswer8] = useState("");
  const [feedbackCompleted, setFeedbackCompleted] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [paymentNotReceivedModal, setPaymentNotReceivedModal] = useState(false);
  const [paymentExceededModal, setPaymentExceededModal] = useState(false);
  const [waitingTrainingConfirmation, setWaitingTrainingConfirmation] = useState(false);
  const [trainerWithStatus6Modal, setTrainerWithStatus6Modal] = useState(false);
  const [trainerWithStatus7Modal, setTrainerWithStatus7Modal] = useState(false);
  const [trainerWithStatus9Modal, setTrainerWithStatus9Modal] = useState(false);
  const [currentTrainerDetails, setCurrentTrainerDetails] = useState(null);
  const [isModifyScheduleModalOpen, setIsModifyScheduleModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitAcceptCompleted, setSubmitAcceptCompleted] = useState(false);
  const [submitTrainerAcceptCompleted, setSubmitTrainerAcceptCompleted] = useState(false);
  const [submitStartDiscussionCompleted, setSubmitStartDiscussionCompleted] = useState(false);
  const [submitTrainingScheduleCompleted, setSubmitTrainingScheduleCompleted] = useState(false);
  const [submitStartTrainingCompleted, setSubmitStartTrainingCompleted] = useState(false);
  const [submitFeedbackCompleted, setSubmitFeedbackCompleted] = useState(false);
  const [submitPaymentCompleted, setSubmitPaymentCompleted] = useState(false);
  const [submitPaymentConfirmationCompleted, setSubmitPaymentConfirmationCompleted] = useState(false);
  const [submitNewPaymentDateCompleted, setSubmitNewPaymentDateCompleted] = useState(false);

  useEffect(() => {
    console.log("trainingID", trainingID);
    fetch(`${process.env.REACT_APP_API_URL}/api/single-training-more-details/${trainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainingDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainingDetails", trainingDetails);
  console.log("data", bbdata);


  const onCancelClick = () => {
    window.location.href = "/app/trainingcompanydashboard";
  };

  useEffect(() => {
    console.log("trainingID", trainingID);
    fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${trainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAppliedTrainerDetails(data);
          // const trainerWithStatus12 = data.find(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 12 && parseInt(trainer.apply_training.previousStatus) !== 19 && !trainingDetails.expectedPaymentDate1 && !trainingDetails.expectedPaymentDate2 && !trainingDetails.expectedPaymentDate3);
          // const trainerMustSubmitProof = data.find(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 12 && parseInt(trainer.apply_training.previousStatus) === 10 && trainingDetails.expectedPaymentDate1 && trainingDetails.expectedPaymentDate2 && trainingDetails.expectedPaymentDate3);
          // const trainerExceededLastPaymentDate = data.find(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 12 && parseInt(trainer.apply_training.previousStatus) === 19);
          // // const trainerExceededLastPaymentDate2 = data.find(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 12 && parseInt(trainer.apply_training.previousStatus) === 10);
          // const trainerWithStatus20 = data.find(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 20);
          // if (trainerWithStatus12 && (trainingDetails.expectedPaymentDate1 && trainingDetails.expectedPaymentDate2 && trainingDetails.expectedPaymentDate3)) {
          // if (trainerWithStatus12) {
          //   console.log("trainerWithStatus12",trainerWithStatus12);
          //   setPaymentNotReceivedModal(true);
          //   setTrainerStatus12(trainerWithStatus12);
          // }
          // const trainerWithStatus12 = data.find(trainer => 
          //   parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
          //   parseInt(trainer.apply_training.previousStatus) !== 19 &&
          //   parseInt(trainer.apply_training.previousStatus) !== 10 &&
          //   !trainingDetails.expectedPaymentDate1 &&
          //   !trainingDetails.expectedPaymentDate2 &&
          //   !trainingDetails.expectedPaymentDate3
          // );

          // const trainerWithStatus12 = data.find(trainer => 
          //   parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
          //   parseInt(trainer.apply_training.previousStatus) !== 19 && 
          // );


          const trainerWithStatus12 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            (parseInt(trainer.apply_training.previousStatus) === 10 || parseInt(trainer.apply_training.previousStatus) === 17 || parseInt(trainer.apply_training.previousStatus) === 18) &&
            (!trainingDetails.expectedPaymentDate1 ||
              !trainingDetails.expectedPaymentDate2 ||
              !trainingDetails.expectedPaymentDate3)
          );

          const trainerMustSubmitProof = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 10 &&
            parseInt(trainer.apply_training.previousStatus) === 19 &&
            trainingDetails.expectedPaymentDate1 &&
            trainingDetails.expectedPaymentDate2 &&
            trainingDetails.expectedPaymentDate3
          );

          const trainerNotReceivedPayment = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            parseInt(trainer.apply_training.previousStatus) === 20 &&
            trainingDetails.expectedPaymentDate1 &&
            trainingDetails.expectedPaymentDate2 &&
            trainingDetails.expectedPaymentDate3
          );

          const trainerExceededLastPaymentDate = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            parseInt(trainer.apply_training.previousStatus) === 19
          );

          const trainerWithStatus20 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 20
          );

          const todayDate = new Date().toISOString().split('T')[0];

          // const trainerWithStatus6 = data.find(trainer =>
          //   parseInt(trainer.apply_training.applyTrainingStatus) === 6 &&
          //   new Date(todayDate) >= new Date(trainingDetails.trainingStartDate) 
          // );

          const trainerWithStatus7 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 7 &&
            new Date(todayDate) > new Date(trainingDetails.trainingEndDate)
          );

          const trainerWithStatus9 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 9 &&
            parseInt(trainer.apply_training.previousStatus) === 8 &&
            new Date(todayDate) > new Date(trainingDetails.expectedPaymentDate)
          );

          const trainerWithStatus17 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 17 &&
            parseInt(trainer.apply_training.previousStatus) === 12 &&
            new Date(todayDate) > new Date(trainingDetails.expectedPaymentDate1)
          );

          const trainerWithStatus18 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 18 &&
            parseInt(trainer.apply_training.previousStatus) === 12 &&
            new Date(todayDate) > new Date(trainingDetails.expectedPaymentDate2)
          );

          const trainerWithStatus19 = data.find(trainer =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 19 &&
            parseInt(trainer.apply_training.previousStatus) === 12 &&
            new Date(todayDate) > new Date(trainingDetails.expectedPaymentDate3)
          );

          if (trainerWithStatus9) {
            console.log("trainerWithStatus9", trainerWithStatus9);
            setTrainerWithStatus9Modal(true);
            setTrainerWithStatus9(trainerWithStatus9);
          }

          if (trainerWithStatus17) {
            console.log("trainerWithStatus17", trainerWithStatus17);
            setTrainerWithStatus9Modal(true);
            setTrainerWithStatus9(trainerWithStatus17);
          }

          if (trainerWithStatus18) {
            console.log("trainerWithStatus17", trainerWithStatus18);
            setTrainerWithStatus9Modal(true);
            setTrainerWithStatus9(trainerWithStatus18);
          }

          if (trainerWithStatus19) {
            console.log("trainerWithStatus19", trainerWithStatus19);
            setTrainerWithStatus9Modal(true);
            setTrainerWithStatus9(trainerWithStatus19);
          }


          if (trainerMustSubmitProof) {
            console.log("trainerMustSubmitProof", trainerMustSubmitProof);
            setPaymentExceededModal(true);
            setTrainerExceededPayment(trainerMustSubmitProof);
          }

          if (trainerWithStatus12) {
            console.log("trainerWithStatus12", trainerWithStatus12);
            setPaymentNotReceivedModal(true);
            setTrainerStatus12(trainerWithStatus12);
          }

          if (trainerNotReceivedPayment) {
            console.log("trainerNotReceivedPayment", trainerNotReceivedPayment);
            setPaymentExceededModal(true);
            setTrainerExceededPayment(trainerNotReceivedPayment);
          }

          if (trainerExceededLastPaymentDate) {
            console.log("trainerExceededLastPaymentDate", trainerExceededLastPaymentDate);
            setPaymentExceededModal(true);
            setTrainerExceededPayment(trainerExceededLastPaymentDate);
          }
          if (trainerWithStatus20) {
            console.log("trainerWithStatus20", trainerWithStatus20);
            setWaitingTrainingConfirmation(true);
            setTrainerStatus20(trainerWithStatus20);
          }

          // if (trainerWithStatus6) {
          //   console.log("trainerWithStatus6",trainerWithStatus6);
          //   setTrainerWithStatus6Modal(true);
          //   setTrainerWithStatus6(trainerWithStatus6);
          // }

          if (trainerWithStatus7) {
            console.log("trainerWithStatus7", trainerWithStatus7);
            setTrainerWithStatus7Modal(true);
            setTrainerWithStatus7(trainerWithStatus7);
          }

        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [trainingDetails, trainingID]);
  console.log("trainer", appliedTrainerDetails);
  console.log("paymentExeededModal", paymentExceededModal);

  const todayDate = new Date().toISOString().split('T')[0];

  function getStatusMessage(trainer) {
    let trainerAppliedStatus = trainer.apply_training;
    console.log("status11111111", trainerAppliedStatus.applyTrainingStatus);
    if (trainerAppliedStatus.applyTrainingStatus === "1") {
      return "Awaiting For your response";
    } else if (trainerAppliedStatus.applyTrainingStatus === "2") {
      return "Partner - Accepted. Awaiting for Trainer's response";
    } else if (trainerAppliedStatus.applyTrainingStatus === "Yes") {
      return "Trainer Declined the training";
    } else if (trainerAppliedStatus.applyTrainingStatus === "3") {
      return "Mutually agreed for the training";
    } else if (trainerAppliedStatus.applyTrainingStatus === "Yes") {
      return "You have Declined the trainer";
    } else if (trainerAppliedStatus.applyTrainingStatus === "4") {
      return "Discussion on-going with trainer";
    } else if (trainerAppliedStatus.applyTrainingStatus === "5") {
      return "Training Scheduling on-going with trainer";
    } else if (trainerAppliedStatus.applyTrainingStatus === "6") {
      return "Training Scheduling confirmed with trainer";
    } else if (trainerAppliedStatus.applyTrainingStatus === "7") {
      return "Training has been Started";
    } else if (trainerAppliedStatus.applyTrainingStatus === "8") {
      return "Training has been Completed";
    } else if (trainerAppliedStatus.applyTrainingStatus === "9") {
      return "Invoice sent by Trainer. Initiate Payment";
    } else if (trainerAppliedStatus.applyTrainingStatus === "10") {
      return "Payment Completed. Awaiting Trainer's Confirmation";
    } else if (trainerAppliedStatus.applyTrainingStatus === "11") {
      return "Payment Received by the Trainer";
    } else if (trainerAppliedStatus.applyTrainingStatus === "12") {
      return "Payment Not Received by the Trainer";
    } else if (trainerAppliedStatus.applyTrainingStatus === "16") {
      return "Trainer request is on-hold";
    } else if (trainerAppliedStatus.applyTrainingStatus === "17") {
      return "1st New Payment Date has been submitted";
    } else if (trainerAppliedStatus.applyTrainingStatus === "18") {
      return "2nd New Payment Date has been submitted";
    } else if (trainerAppliedStatus.applyTrainingStatus === "19") {
      return "Final New Payment Date has been submitted";
    } else if (trainerAppliedStatus.applyTrainingStatus === "20") {
      return "Final Payment Completed";
    } else if (trainerAppliedStatus.applyTrainingStatus === "21") {
      return "Training has been cancelled";
    } else {
      return "Unknown Status";
    }
  }

  const navigate = useNavigate();

  const onAppliedMoreDetailsClick = (trainer) => {
    let trainerDetails = trainer.apply_training;
    console.log("training", trainerDetails.id);
    navigate(`/app/appliedtrainermoredetails/${trainerDetails.id}/`);
  };


  const onRemainderClick = (trainer) => {
    setLoading(true);
    setMaxRemainderCount(false);
    const data = {
      id: trainer.apply_training.id,
      premiumStatus: trainingDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/apply-training-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitRemainderCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
          setLoading(false);
        } else if (data.message === "We have re-sent you a link to the company to accept your request") {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(true);
          setLoading(false);
        } else {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  // const onRemainderClick = (trainer) => {
  //   console.log("12312312", trainer);
  //   setLoading(true);
  //   setMaxRemainderCount(false);
  //   const data = {
  //     id: trainingID,
  //     premiumStatus: trainingDetails.premiumStatus,
  //   };
  //   console.log(JSON.stringify(data));
  //   fetch(`${process.env.REACT_APP_API_URL}/api/apply-training-reminder/`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     body: JSON.stringify(data),
  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         return response.json();
  //       } else {
  //         setSubmitRemainderCompleted(false);
  //         throw new Error("Profile is not created. Something went wrong");
  //       }
  //     })
  //     .then((data) => {
  //       console.log("Response from backend:", data.message);
  //       if (data.message === "Remainder reached maximum for the day") {
  //         setResponseFromDB(data.message);
  //         setMaxRemainderCount(true);
  //         setLoading(false);
  //       } else if (data.message === "We have re-sent you a link to the company to accept your request") {
  //         setResponseFromDB(data.message);
  //         setSubmitRemainderCompleted(true);
  //         setLoading(false);
  //       } else {
  //         setResponseFromDB(data.message);
  //         setSubmitRemainderCompleted(false);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error:", error.message);
  //     });
  // };

  // function getFeedbackStatus(trainer) {
  //   console.log("trainer",trainer);
  //   let trainerId = trainer.apply_training.appliedTrainerID;
  //   let trainingCompanyID = trainer.apply_training.trainingCompanyUserID;
  //   // let trainingID = trainingID.toString();
  //   fetch(`${process.env.REACT_APP_API_URL}/api/check-feedback-exists/${trainerId}/${trainingCompanyID}/${trainingID}/`, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + localStorage.getItem('token'),
  //     },
  //   })
  //     .then((resp) => resp.json())
  //     .then((data) => {
  //       if (!data) {
  //         console.log("123333333333333333333333333333");
  //         console.log("details",data);
  //         setFeedbackStatusAvailable(true);
  //       } else {
  //         console.log("data inside1111111",data);
  //         if(data === true){
  //           setFeedbackStatusAvailable(false);
  //         } else{
  //           setFeedbackStatusAvailable(true);
  //         } 
  //       }
  //     }) 
  //     .catch((error) => {
  //       console.error(error);
  //     });      
  // }

  console.log("paymentNotReceivedModal", paymentNotReceivedModal);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-template-view/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          const trainerFeedbackQuestions = data.filter(
            (question) => question.toWhom === "TrainingCompany"
          );
          setFeedbackQuestions(trainerFeedbackQuestions);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("feedbackQuestions", feedbackQuestions);

  const handleRatingChange = (event, newValue) => {
    // Update the feedbackRating state with the selected rating
    setFeedbackRating(newValue);
  };


  const onSubmitFeebackClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    const data = {
      trainerID: trainer.apply_training.appliedTrainerID,
      trainingCompanyID: trainer.apply_training.trainingCompanyUserID,
      trainingID: trainingID,
      toWhom: "Trainer",
      rating1: feedbackRating,
      question1: feedbackAnswer1,
      question2: feedbackAnswer2,
      question3: feedbackAnswer3,
      question4: feedbackAnswer4,
      question5: feedbackAnswer5,
      question6: feedbackAnswer6,
      question7: feedbackAnswer7,
      question8: feedbackAnswer8,
      status: "Active",
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-api-view/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setFeedbackStatusAvailable(false);
          setSubmitFeedbackCompleted(true);
          setLoading(false);
        } else {
          setFeedbackStatusAvailable(true);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  console.log("feedbackStatus", feedbackStatusAvailable);

  const onResetClick = () => {
    // console.log("112121reset", trainer);
    // console.log("111111111111111111",trainer);
    // let applyTraining = trainer.apply_training;
    setLoading(true);
    const data = {
      selectedTrainingID: trainingID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-reset/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });

    // Separate trainers with status 5 and 6
    // const trainersWithStatus5 = trainer.filter(
    //   (trainers) => parseInt(trainers.apply_training.applyTrainingStatus) === 5
    // );

    // const trainersWithStatus6 = trainer.filter(
    //   (trainers) => parseInt(trainers.apply_training.applyTrainingStatus) === 6
    // );

    // console.log("Trainers with applyTrainingStatus === 5", trainersWithStatus5);
    // console.log("Trainers with applyTrainingStatus === 6", trainersWithStatus6);

    // // Function to update applyTrainingStatus for trainers
    // const updateTrainingStatus = (status, trainer) => {
    //   trainer.forEach((trainers) => {
    //     let applyTraining = trainers.apply_training;
    //     const data = {
    //       applyTrainingStatus: status,
    //       appliedTrainerID: applyTraining.appliedTrainerID,
    //       trainingCompanyUserID: applyTraining.trainingCompanyUserID,
    //       selectedTrainingID: applyTraining.selectedTrainingID,
    //       selectedTrainingName: applyTraining.selectedTrainingName,
    //     };
    //     console.log(JSON.stringify(data));

    //     // Call the API with the updated status
    //     fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(data),
    //     })
    //       .then((response) => {
    //         if (response.ok) {
    //           console.log("API call successful");
    //           setSubmitAcceptCompleted(true);
    //         } else {
    //           setSubmitAcceptCompleted(false);
    //           throw new Error("Response not posted. Something went wrong");
    //         }
    //       })
    //       .then((data) => {
    //         console.log("API call response", data);
    //       })
    //       .catch((error) => {
    //         console.log("API call error", error.message);
    //       });
    //   });
    // };

    // // Update status for trainers with status 5 and 6
    // updateTrainingStatus("16", trainersWithStatus5);
    // updateTrainingStatus("5", trainersWithStatus6);
  };

  const onTrainingStartedResetClick = () => {
    setLoading(true);
    const data = {
      selectedTrainingID: trainingID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-reset/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setFeedbackStatusAvailable(true);
          setSubmitAcceptCompleted(true);
          setLoading(fabClasses);
        } else {
          setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onCancelTrainingClick = (trainer) => {
    setLoading(true);
    // const data = {
    //   applyTrainingStatus:"21",
    //   previousStatus:"1",
    //   appliedTrainerID:applyTraining.appliedTrainerID,
    //   trainingCompanyUserID:applyTraining.trainingCompanyUserID,
    //   selectedTrainingID:applyTraining.selectedTrainingID,
    //   selectedTrainingName:applyTraining.selectedTrainingName,
    // };
    // console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/training-cancel-update/${trainingID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitCancelTraining(true);
          setLoading(false);
        } else {
          setSubmitCancelTraining(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  const onAgreeClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "2",
      previousStatus: "1",
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitTrainerAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitTrainerAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onStartDiscussionClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "4",
      previousStatus: "3",
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitStartDiscussionCompleted(true);
          setLoading(false);
        } else {
          setSubmitStartDiscussionCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const today = new Date().toISOString().split('T')[0];

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);
  const maxDateString = maxDate.toISOString().split('T')[0];

  const handleCountryCurrencyChange = (event) => {
    const selectedISO = event.target.value;
    setSelectedCurrencyCountry(selectedISO);

    const currencyInfo = getAllInfoByISO(selectedISO);
    setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  };

  console.log("selectedCurrencyCountry", selectedCurrencyCountry);

  const handleTrainingStartDateChange = (event) => {
    setTrainingStartDate(event.target.value);
  };

  const handleTrainingEndDateChange = (event) => {
    setTrainingEndDate(event.target.value);
  };

  const [finalizedCommercialsError, setFinalizedCommercialsError] = useState(false);

  const handleFinalizedCommercialsChange = (event) => {
    const input = event.target.value;
    const regex = /^[0-9]+$/;
    const isValid = !regex.test(input);
    setFinalizedCommercialsError(isValid);
    setFinalizedCommercials(event.target.value);
  };

  const handleExpectedPaymentDateChange = (event) => {
    setExpectedPaymentDate(event.target.value);
  };

  const handleExpectedNewPaymentDateChange = (event) => {
    setExpectedNewPaymentDate(event.target.value);
  };

  const handleFinalizedStartTimeChange = (event) => {
    setFinalizedStartTime(event.target.value);
  };

  const handleFinalizedEndTimeChange = (event) => {
    setFinalizedEndTime(event.target.value);
  };

  const handleFinalizedTrainingScheduleChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setFinalizedTrainingSchedule(formattedDates);
  };

  const handleFinalizedTrainingTimingChange = (e) => {
    setFinalizedTrainingTiming(e.target.value);
  };

  const onScheduleCancelClick = () => {
    setIsModalOpen(false);
    setFinalizedCommercialsError(false);
    setTrainingStartDate("");
    setTrainingEndDate("");
    setExpectedPaymentDate("");
    setFinalizedStartTime("");
    setFinalizedEndTime("");
    setFinalizedTrainingSchedule("");
    setFinalizedTrainingTiming("");
    setFinalizedCommercials("");
    setSelectedCurrencyCountry("");
    setCurrency("");
  };

  const [scheduleSelectedTrainer, setScheduleSelectedTrainer] = useState(null);

  const onScheduleTrainingClick = (trainer) => {
    console.log("@#2@@#@#", trainer);
    setScheduleSelectedTrainer(trainer);
    setIsModalOpen(true);
    // console.log("111111111111111111", trainer);
    // let applyTraining = trainer.apply_training;
    // const data = {
    //   applyTrainingStatus: "5",
    //   previousStatus: "4",
    //   appliedTrainerID: applyTraining.appliedTrainerID,
    //   trainingCompanyUserID: applyTraining.trainingCompanyUserID,
    //   selectedTrainingID: applyTraining.selectedTrainingID,
    //   selectedTrainingName: applyTraining.selectedTrainingName,
    // };

    // console.log(JSON.stringify(data));

    // fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(data),
    // })
    //   .then((response) => {
    //     if (response.ok) {
    //       console.log("First POST call successful");

    //       // Set up an array to store promises for the second POST calls
    //       const secondPostPromises = [];

    //       // Handle the second POST calls for each trainer in restTrainers
    //       const restTrainers = appliedTrainerDetails.filter(
    //         (trainers) => parseInt(trainers.user_id) !== parseInt(trainer.user_id)
    //       );

    //       restTrainers.forEach((restTrainer) => {
    //         const secondPostData = {
    //           applyTrainingStatus: "16",
    //           previousStatus: restTrainer.apply_training.applyTrainingStatus,
    //           appliedTrainerID: restTrainer.apply_training.appliedTrainerID,
    //           trainingCompanyUserID: restTrainer.apply_training.trainingCompanyUserID,
    //           selectedTrainingID: restTrainer.apply_training.selectedTrainingID,
    //           selectedTrainingName: restTrainer.apply_training.selectedTrainingName,
    //         };

    //         console.log(JSON.stringify(secondPostData));

    //         const secondPostPromise = fetch(
    //           `${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`,
    //           {
    //             method: "POST",
    //             headers: {
    //               "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(secondPostData),
    //           }
    //         );

    //         secondPostPromises.push(secondPostPromise);
    //       });

    //       // Wait for all second POST calls to complete
    //       Promise.all(secondPostPromises)
    //         .then(() => {
    //           console.log("All second POST calls successful");
    //           setSubmitAcceptCompleted(true);
    //         })
    //         .catch((error) => {
    //           console.log("Error in second POST calls", error.message);
    //           setSubmitAcceptCompleted(false);
    //         });
    //     } else {
    //       setSubmitAcceptCompleted(false);
    //       throw new Error("Response not posted. Something went wrong");
    //     }
    //   })
    //   .then((data) => {
    //     console.log("fffffffffffffffff");
    //   })
    //   .catch((error) => {
    //     console.log("oooooooooooooooo", error.message);
    //     setSubmitAcceptCompleted(false);
    //   });
  };

  console.log("scheduleSelectedTrainer", scheduleSelectedTrainer);
  const onSubmitScheduleClick = (trainer) => {
    const scheduleTraining = () => {
      // Your existing code for onScheduleTrainingClick
      setLoading(true);
      console.log("111111111111111111", trainer);
      let applyTraining = trainer.apply_training;
      const data = {
        applyTrainingStatus: "5",
        previousStatus: "4",
        appliedTrainerID: applyTraining.appliedTrainerID,
        trainingCompanyUserID: applyTraining.trainingCompanyUserID,
        selectedTrainingID: applyTraining.selectedTrainingID,
        selectedTrainingName: applyTraining.selectedTrainingName,
      };

      console.log(JSON.stringify(data));

      return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.ok) {
            console.log("First POST call successful");

            // Set up an array to store promises for the second POST calls
            const secondPostPromises = [];

            // Handle the second POST calls for each trainer in restTrainers
            const restTrainers = appliedTrainerDetails.filter(
              (trainers) => parseInt(trainers.user_id) !== parseInt(trainer.user_id)
            );

            console.log("restTrainers@@@@@@", restTrainers);
            restTrainers.forEach((restTrainer) => {
              const secondPostData = {
                applyTrainingStatus: "16",
                previousStatus: restTrainer.apply_training.applyTrainingStatus,
                appliedTrainerID: restTrainer.apply_training.appliedTrainerID,
                trainingCompanyUserID: restTrainer.apply_training.trainingCompanyUserID,
                selectedTrainingID: restTrainer.apply_training.selectedTrainingID,
                selectedTrainingName: restTrainer.apply_training.selectedTrainingName,
              };

              console.log(JSON.stringify(secondPostData));

              const secondPostPromise = fetch(
                `${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(secondPostData),
                }
              );

              secondPostPromises.push(secondPostPromise);
            });

            // Wait for all second POST calls to complete
            return Promise.all(secondPostPromises)
              .then(() => {
                console.log("All second POST calls successful");
                setSubmitTrainingScheduleCompleted(true);
                // setLoading(false);
              })
              .catch((error) => {
                console.log("Error in second POST calls", error.message);
                setSubmitTrainingScheduleCompleted(false);
              });
          } else {
            setSubmitTrainingScheduleCompleted(false);
            throw new Error("Response not posted. Something went wrong");
          }
        });
    };

    // Your existing code for onSubmitScheduleClick
    const data = {
      trainingStartDate: trainingStartDate,
      trainingEndDate: trainingEndDate,
      finalizedStarttime: finalizedStartTime,
      finalizedEndtime: finalizedEndTime,
      finalizedScheduledate: finalizedTrainingSchedule,
      finalizedTrainingHour: finalizedTrainingTiming,
      finalizedSelectedCommercialsCountry: selectedCurrencyCountry,
      finalizedCommercialsCurrency: currency,
      finalizedCommercials: finalizedCommercials,
      expectedPaymentDate: expectedPaymentDate,
    };
    console.log(JSON.stringify(data));
    return fetch(`${process.env.REACT_APP_API_URL}/api/training-update-date/${trainingID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("First POST call for training-update-date successful");
          // After the successful training-update-date API call, call the scheduleTraining function
          setIsModalOpen(false);
          return scheduleTraining();
        } else {
          setSubmitTrainingScheduleCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then(() => {
        console.log("All API calls successful");
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in API calls", error.message);
        setSubmitTrainingScheduleCompleted(false);
      });
  };

  // const onScheduleTrainingClick = (trainer) => {
  //   console.log("111111111111111111",trainer);
  //   // const trainersWithStatus6 = trainer.filter(
  //   //       (trainers) => parseInt(trainers.apply_training.applyTrainingStatus) === 6
  //   //     );

  //   //     const trainersWithoutStatus6 = trainer.filter(
  //   //       (trainers) => parseInt(trainers.apply_training.applyTrainingStatus) !== 6
  //   //     );

  //   //     console.log("Trainers with trainersWithStatus6 ", trainersWithStatus6);
  //   //     console.log("Trainers with trainersWithoutStatus6 ", trainersWithoutStatus6);

  //   //     const updateTrainingStatus = (status, trainer) => {
  //   //       trainer.forEach((trainers) => {
  //   //         let applyTraining = trainers.apply_training;
  //   //         const data = {
  //   //           applyTrainingStatus: status,
  //   //           appliedTrainerID: applyTraining.appliedTrainerID,
  //   //           trainingCompanyUserID: applyTraining.trainingCompanyUserID,
  //   //           selectedTrainingID: applyTraining.selectedTrainingID,
  //   //           selectedTrainingName: applyTraining.selectedTrainingName,
  //   //         };
  //   //         console.log(JSON.stringify(data));

  //   //         // Call the API with the updated status
  //   //         fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
  //   //           method: "POST",
  //   //           headers: {
  //   //             "Content-Type": "application/json",
  //   //           },
  //   //           body: JSON.stringify(data),
  //   //         })
  //   //           .then((response) => {
  //   //             if (response.ok) {
  //   //               console.log("API call successful");
  //   //               setSubmitAcceptCompleted(true);
  //   //             } else {
  //   //               setSubmitAcceptCompleted(false);
  //   //               throw new Error("Response not posted. Something went wrong");
  //   //             }
  //   //           })
  //   //           .then((data) => {
  //   //             console.log("API call response", data);
  //   //           })
  //   //           .catch((error) => {
  //   //             console.log("API call error", error.message);
  //   //           });
  //   //       });
  //   //     };

  //   //     // Update status for trainers with status 5 and 6
  //   //     updateTrainingStatus("7", trainersWithStatus6);
  //   //     updateTrainingStatus("16", trainersWithoutStatus6);
  //     // };
  //   let applyTraining = trainer.apply_training;
  //   const data = {
  //     applyTrainingStatus:"5",
  //     previousStatus:"4",
  //     appliedTrainerID:applyTraining.appliedTrainerID,
  //     trainingCompanyUserID:applyTraining.trainingCompanyUserID,
  //     selectedTrainingID:applyTraining.selectedTrainingID,
  //     selectedTrainingName:applyTraining.selectedTrainingName,
  //   };
  //   console.log(JSON.stringify(data));
  //   fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(data),

  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         console.log("aaaaaaaaaaa");
  //         // setSubmitAcceptCompleted(true);
  //         let trainerId = trainer.user_id;
  //         const restTrainers = appliedTrainerDetails.filter(
  //           (trainers) => parseInt(trainers.user_id) !== parseInt(trainer.user_id)
  //         );

  //         console.log("restTrainers",restTrainers);
  //         console.log("selecgtedTrainerId",trainerId);
  //       } else {
  //         setSubmitAcceptCompleted(false);
  //         throw new Error("Response not posted. Something went wrong");
  //       }
  //     })
  //     .then((data) => {
  //       console.log("fffffffffffffffff");
  //     })
  //     .catch((error) => {
  //       console.log("oooooooooooooooo", error.message);
  //     });
  // };

  const onStartTrainingClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    //   const trainersWithStatus6 = trainer.filter(
    //     (trainers) => parseInt(trainers.apply_training.applyTrainingStatus) === 6
    //   );

    //   const trainersWithoutStatus6 = trainer.filter(
    //     (trainers) => parseInt(trainers.apply_training.applyTrainingStatus) !== 6
    //   );

    //   console.log("Trainers with trainersWithStatus6 ", trainersWithStatus6);
    //   console.log("Trainers with trainersWithoutStatus6 ", trainersWithoutStatus6);

    //   const updateTrainingStatus = (status, trainer) => {
    //     trainer.forEach((trainers) => {
    //       let applyTraining = trainers.apply_training;
    //       const data = {
    //         applyTrainingStatus: status,
    //         appliedTrainerID: applyTraining.appliedTrainerID,
    //         trainingCompanyUserID: applyTraining.trainingCompanyUserID,
    //         selectedTrainingID: applyTraining.selectedTrainingID,
    //         selectedTrainingName: applyTraining.selectedTrainingName,
    //       };
    //       console.log(JSON.stringify(data));

    //       // Call the API with the updated status
    //       fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify(data),
    //       })
    //         .then((response) => {
    //           if (response.ok) {
    //             console.log("API call successful");
    //             setSubmitAcceptCompleted(true);
    //           } else {
    //             setSubmitAcceptCompleted(false);
    //             throw new Error("Response not posted. Something went wrong");
    //           }
    //         })
    //         .then((data) => {
    //           console.log("API call response", data);
    //         })
    //         .catch((error) => {
    //           console.log("API call error", error.message);
    //         });
    //     });
    //   };

    //   // Update status for trainers with status 5 and 6
    //   updateTrainingStatus("7", trainersWithStatus6);
    //   updateTrainingStatus("16", trainersWithoutStatus6);
    // };

    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "7",
      previousStatus: "6",
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitStartTrainingCompleted(true);
          setLoading(false);
        } else {
          setSubmitStartTrainingCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onTrainingCompletedClick = (trainer) => {
    console.log("111111111111111111", trainer);
    setLoading(true);
    setTrainerWithStatus7Modal(false);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "8",
      previousStatus: "7",
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setFeedbackStatusAvailable(true);
          // setSubmitAcceptCompleted(true);      
          setLoading(false);
        } else {
          // setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  console.log("feedbackStatus", feedbackStatusAvailable);

  const onPaymentCompletedClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "10",
      previousStatus: applyTraining.applyTrainingStatus,
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setTrainerWithStatus9Modal(false);
          setSubmitPaymentCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  // const onFinalPaymentCompletedClick = (trainer) => {
  //   console.log("########",trainer);
  //   let applyTraining = trainer.apply_training;
  //   const data = {
  //     applyTrainingStatus:"20",
  //     previousStatus:applyTraining.applyTrainingStatus,
  //     appliedTrainerID:applyTraining.appliedTrainerID,
  //     trainingCompanyUserID:applyTraining.trainingCompanyUserID,
  //     selectedTrainingID:applyTraining.selectedTrainingID,
  //     selectedTrainingName:applyTraining.selectedTrainingName,
  //   };
  //   console.log(JSON.stringify(data));
  //   fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(data),

  //   })
  //     .then((response) => {
  //       if (response.ok && paymentProof) {
  //         console.log("aaaaaaaaaaa");
  //         await uploadPaymentProofToS3(paymentProof);
  //         console.log("Payment Proof uploaded successfully");
  //         setSubmitAcceptCompleted(true);
  //       } else {
  //         setSubmitAcceptCompleted(false);
  //         throw new Error("Response not posted. Something went wrong");
  //       }
  //     })
  //     .then((data) => {
  //       console.log("fffffffffffffffff");
  //     })
  //     .catch((error) => {
  //       console.log("oooooooooooooooo", error.message);
  //     });
  // };

  const onFinalPaymentCompletedClick = (trainer) => {
    setLoading(true);
    setPaymentExceededModal(false);
    console.log("########", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "20",
      previousStatus: applyTraining.applyTrainingStatus,
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          // await uploadPaymentProofToS3(paymentProof);
          // console.log("Payment Proof uploaded successfully");
          // setSubmitAcceptCompleted(true);          
          setWaitingTrainingConfirmation(true);
          setLoading(false);
        } else {
          // setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onNewPaymentCompletedClick = (trainer) => {
    setLoading(true);
    console.log("########", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "10",
      previousStatus: applyTraining.applyTrainingStatus,
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setPaymentNotReceivedModal(false);
          setSubmitPaymentConfirmationCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentConfirmationCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  const onSubmitNewPaymentClick = (trainer) => {
    setLoading(true);
    console.log("trainingDetails", trainingDetails);
    console.log("trainer", trainer);

    // Check conditions and determine the target payment date property
    let targetPaymentDateProperty;
    let applyTrainingStatus; // Initialize applyTrainingStatus variable
    if (trainingDetails.expectedPaymentDate && !trainingDetails.expectedPaymentDate1) {
      targetPaymentDateProperty = "expectedPaymentDate1";
      applyTrainingStatus = "17"; // Update applyTrainingStatus based on targetPaymentDateProperty
    } else if (trainingDetails.expectedPaymentDate && trainingDetails.expectedPaymentDate1 && !trainingDetails.expectedPaymentDate2) {
      targetPaymentDateProperty = "expectedPaymentDate2";
      applyTrainingStatus = "18"; // Update applyTrainingStatus based on targetPaymentDateProperty
    } else if (trainingDetails.expectedPaymentDate && trainingDetails.expectedPaymentDate1 && trainingDetails.expectedPaymentDate2 && !trainingDetails.expectedPaymentDate3) {
      targetPaymentDateProperty = "expectedPaymentDate3";
      applyTrainingStatus = "19"; // Update applyTrainingStatus based on targetPaymentDateProperty
    } else {
      // Handle other cases or throw an error if needed
      console.error("Invalid conditions for updating payment date");
      return;
    }

    const paymentUpdateData = {
      [targetPaymentDateProperty]: expectedNewPaymentDate,
    };

    console.log(JSON.stringify(paymentUpdateData));

    // Execute both API calls concurrently
    Promise.all([
      fetch(`${process.env.REACT_APP_API_URL}/api/training-update-date/${trainingID}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentUpdateData),
      }),
      // Add more API calls here if needed
    ])
      .then((responses) => {
        const [updateDateResponse] = responses;
        if (updateDateResponse.ok) {
          console.log("Update date success");
          setPaymentNotReceivedModal(false);
          setSubmitNewPaymentDateCompleted(true);

          // Continue with the second API call (trainerdashboard-status-intodb POST api)
          const trainerStatusData = {
            applyTrainingStatus: applyTrainingStatus, // Use the updated applyTrainingStatus value
            previousStatus: trainer.apply_training.applyTrainingStatus,
            appliedTrainerID: trainer.apply_training.appliedTrainerID,
            trainingCompanyUserID: trainer.apply_training.trainingCompanyUserID,
            selectedTrainingID: trainer.apply_training.selectedTrainingID,
            selectedTrainingName: trainer.apply_training.selectedTrainingName,
          };

          return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(trainerStatusData),
          });
        } else {
          setPaymentNotReceivedModal(true);
          setSubmitNewPaymentDateCompleted(false);
          throw new Error("Update date failed. Something went wrong");
        }
      })
      .then((trainerStatusResponse) => {
        if (trainerStatusResponse.ok) {
          console.log("Trainer status update success");
          setLoading(false);
          // Do any additional actions on success of trainerdashboard-status-intodb POST api
        } else {
          console.error("Trainer status update failed. Something went wrong");
          setSubmitNewPaymentDateCompleted(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };



  const DialogTrainerAcceptClose = () => {
    setSubmitTrainerAcceptCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogStartDiscussionClose = () => {
    setSubmitStartDiscussionCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogTrainingScheduleClose = () => {
    setSubmitTrainingScheduleCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogTrainingCancelClose = () => {
    setSubmitCancelTraining(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogProfileClose = () => {
    setSubmitRemainderCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogProfileStartTrainingClose = () => {
    setSubmitStartTrainingCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogProfileFeedbackClose = () => {
    setSubmitFeedbackCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogProfilePaymentCompletedClose = () => {
    setSubmitPaymentCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };

  const DialogProfileNewPaymentDateClose = () => {
    setSubmitNewPaymentDateCompleted(false);
    window.location.href = `/app/activetrainingmoredetails/${trainingID}/`;
  };


  const paymentProofFileInputRef = useRef(null);
  const [fileUploaded, setFileUploaded] = useState(false);

  const handleUploadClick = () => {
    paymentProofFileInputRef.current.click();
  };

  const [paymentProof, setPaymentProof] = useState([]);
  const [s3BucketURL, setS3BucketURL] = useState(null);

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_S3_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  });

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainingcompanyhub/${id}_${userName}/payment-proof/`;
    setS3BucketURL(bucketURL);
  }, [localStorage.getItem("user")])

  // const uploadPaymentProofToS3 = async (file) => {
  //   const s3 = new AWS.S3();
  //   const params = {
  //     Bucket: process.env.REACT_APP_S3_BUCKET,
  //     Key: `${s3BucketURL}/payment-proof/${file.name}`,
  //     Body: file,
  //   };

  //   try {
  //     const result = await s3.upload(params).promise();
  //     console.log('File uploaded successfully:', result.Location);
  //   } catch (error) {
  //     console.error('Error uploading file:', error);
  //   }
  // };
  const [error, setError] = useState(null);

  const handlePaymentProofUploadChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png', 'pdf'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 300 * 1024) {
        // File size exceeds 300kb
        setError("File size should be maximum 300kb.");
        return;
      }

      // Reset error if validation is successful
      setError(null);

      const renamedFile = new File([selectedFile], `${trainingDetails.trainingName}_paymentProof.${fileExtension}`, { type: selectedFile.type });

      setPaymentProof(renamedFile);
      const formData = new FormData();
      formData.append('files', renamedFile);

      fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}`, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json(console.log("response", response)))
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          console.error('Error uploading file:', error);
        });
    }
    setFileUploaded(true);
  };


  console.log("paymentProof", paymentProof);

  function getTrainingStatusMessage(training) {
    console.log("training.status", training.status);
    if (training.status === "Active") {
      return "Training is Active";
    } else if (training.status === "6") {
      return "Training Scheduling confirmed with trainer";
    } else if (training.status === "7") {
      return "Training has been Started";
    } else if (training.status === "8") {
      return "Training has been Completed";
    } else if (training.status === "9") {
      return "Invoice sent to the Training Partner";
    } else if (training.status === "10") {
      return "Payment Completed";
    } else if (training.status === "11") {
      return "Training Completed";
    } else if (training.status === "12") {
      return "Payment Not Received by the Trainer";
    } else if (training.status === "17") {
      return "1st New Payment Date has been submitted";
    } else if (training.status === "18") {
      return "2nd New Payment Date has been submitted";
    } else if (training.status === "19") {
      return "Final New Payment Date has been submitted";
    } else if (training.status === "21") {
      return "Training Cancelled";
    } else {
      return "Unknown Status";
    }
  }

  const handleTrainingCompanyTocDownloadClick = (trainingDetails) => {

    console.log("url", trainingDetails);
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainingDetails.TOCURL}/trainingpost/${trainingDetails.trainingName}_toc`;
  };

  const onModifyScheduleCancelClick = () => {
    setIsModifyScheduleModalOpen(false);
    setFinalizedCommercialsError(false);
    setTrainingStartDate("");
    setTrainingEndDate("");
    setExpectedPaymentDate("");
    setFinalizedStartTime("");
    setFinalizedEndTime("");
    setFinalizedTrainingSchedule("");
    setFinalizedTrainingTiming("");
    setFinalizedCommercials("");
    setSelectedCurrencyCountry("");
    setCurrency("");
  };

  const handleModifyScheduleTrainingClick = (trainingDetails) => {
    console.log("schedule", trainingDetails);
    setIsModifyScheduleModalOpen(true);
  };

  const handleEditTrainingClick = (trainingDetails) => {
    console.log("edit", trainingDetails);
    navigate(`/app/edittrainingpost/${trainingDetails.id}/`);
  };

  useEffect(() => {
    if (isModifyScheduleModalOpen && trainingDetails.trainingStartDate) {
      setTrainingStartDate(trainingDetails.trainingStartDate);
    }

    if (isModifyScheduleModalOpen && trainingDetails.trainingEndDate) {
      setTrainingEndDate(trainingDetails.trainingEndDate);
    }

    if (isModifyScheduleModalOpen && trainingDetails.finalizedStarttime) {
      setFinalizedStartTime(trainingDetails.finalizedStarttime);
    }

    if (isModifyScheduleModalOpen && trainingDetails.finalizedEndtime) {
      setFinalizedEndTime(trainingDetails.finalizedEndtime);
    }

    if (isModifyScheduleModalOpen && trainingDetails.finalizedScheduledate) {
      try {
        const cleanedString = trainingDetails.finalizedScheduledate.replace(/['\[\]]/g, "");
        const parsedArray = cleanedString.split(", ");
        const filteredArray = parsedArray.filter(item => item.trim() !== "");

        if (Array.isArray(filteredArray)) {
          setFinalizedTrainingSchedule(filteredArray);
          console.log("pqpqpqpq", filteredArray);
        } else {
          console.error('Parsed value is not an array.');
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }

    if (isModifyScheduleModalOpen && trainingDetails.finalizedTrainingHour) {
      setFinalizedTrainingTiming(trainingDetails.finalizedTrainingHour);
    }

    if (isModifyScheduleModalOpen && trainingDetails.finalizedSelectedCommercialsCountry) {
      setSelectedCurrencyCountry(trainingDetails.finalizedSelectedCommercialsCountry);
    }

    if (isModifyScheduleModalOpen && trainingDetails.currency) {
      setCurrency(trainingDetails.currency);
    }

    if (isModifyScheduleModalOpen && trainingDetails.finalizedCommercials) {
      setFinalizedCommercials(trainingDetails.finalizedCommercials);
    }

    if (isModifyScheduleModalOpen && trainingDetails.expectedPaymentDate) {
      setExpectedPaymentDate(trainingDetails.expectedPaymentDate);
    }

  }, [isModifyScheduleModalOpen, trainingDetails]);

  // const onSubmitModfiyScheduleClick = () => {
  //   const data = {
  //     trainingStartDate: trainingStartDate,
  //     trainingEndDate: trainingEndDate,
  //     finalizedStarttime: finalizedStartTime,
  //     finalizedEndtime: finalizedEndTime,
  //     finalizedScheduledate: finalizedTrainingSchedule,
  //     finalizedTrainingHour: finalizedTrainingTiming,
  //     finalizedSelectedCommercialsCountry: selectedCurrencyCountry,
  //     finalizedCommercialsCurrency:currency,
  //     finalizedCommercials: finalizedCommercials,
  //     expectedPaymentDate: expectedPaymentDate,
  //   };
  //   console.log(JSON.stringify(data));
  //   fetch(`${process.env.REACT_APP_API_URL}/api/training-update-date/${trainingID}/`, {
  //     method: "PUT",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(data),

  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         console.log("aaaaaaaaaaa");
  //         setSubmitAcceptCompleted(true);
  //       } else {
  //         setSubmitAcceptCompleted(false);
  //         throw new Error("Response not posted. Something went wrong");
  //       }
  //     })
  //     .then((data) => {
  //       console.log("fffffffffffffffff");
  //     })
  //     .catch((error) => {
  //       console.log("oooooooooooooooo", error.message);
  //     });
  // };

  const onSubmitModfiyScheduleClick = () => {
    setLoading(true);
    const firstApiData = {
      trainingStartDate: trainingStartDate,
      trainingEndDate: trainingEndDate,
      finalizedStarttime: finalizedStartTime,
      finalizedEndtime: finalizedEndTime,
      finalizedScheduledate: finalizedTrainingSchedule,
      finalizedTrainingHour: finalizedTrainingTiming,
      finalizedSelectedCommercialsCountry: selectedCurrencyCountry,
      finalizedCommercialsCurrency: currency,
      finalizedCommercials: finalizedCommercials,
      expectedPaymentDate: expectedPaymentDate,
      status: "Active",
    };

    console.log(JSON.stringify(firstApiData));

    fetch(`${process.env.REACT_APP_API_URL}/api/training-update-date/${trainingID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(firstApiData),
    })
      .then((response) => {
        if (response.ok) {
          console.log("First API success");

          // Filter trainers based on applyTrainingStatus not equal to 16
          const filteredTrainers = appliedTrainerDetails.filter(
            (trainer) => trainer.apply_training.applyTrainingStatus !== "16"
          );

          if (filteredTrainers.length === 0) {
            // Handle the case when no eligible trainers are found
            console.log("No eligible trainers found");
            setSubmitAcceptCompleted(false);
            throw new Error("No eligible trainers found");
          }

          // Pick the first trainer from the filtered list
          const selectedTrainer = filteredTrainers[0];

          // Chain the second API call with the selected trainer
          return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              applyTrainingStatus: "5",
              previousStatus: "4",
              appliedTrainerID: selectedTrainer.apply_training.appliedTrainerID,
              trainingCompanyUserID: selectedTrainer.apply_training.trainingCompanyUserID,
              selectedTrainingID: selectedTrainer.apply_training.selectedTrainingID,
              selectedTrainingName: selectedTrainer.apply_training.selectedTrainingName,
            }),
          });
        } else {
          setSubmitAcceptCompleted(false);
          throw new Error("First API: Response not posted. Something went wrong");
        }
      })
      .then((secondApiResponse) => {
        if (secondApiResponse.ok) {
          console.log("Second API success");
          setSubmitAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitAcceptCompleted(false);
          throw new Error("Second API: Response not posted. Something went wrong");
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  };


  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={routes}
        />
        <MKBox bgColor="white">
          {/* <MKBox
          minHeight="35rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.3),
                rgba(gradients.dark.state, 0.3)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            display: "grid",
            placeItems: "center",
          }}
        /> */}
          <Card
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
          >
            <div>
              {maxRemainderCount ? (
                <MKAlert color="error" dismissible >
                  You've reached the daily remainder limit !
                </MKAlert>
              ) : (
                ""
              )}
            </div>
            <Dialog
              open={submitCancelTraining}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Important Update!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  We've processed the cancellation of your training with empathy
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitCancelTraining(false); DialogTrainingCancelClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitStartTrainingCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  The trainer has been notified about the start of the training.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitStartTrainingCompleted(false); DialogProfileStartTrainingClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitFeedbackCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Thank you!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your Feedback has been submitted to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitFeedbackCompleted(false); DialogProfileFeedbackClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitTrainerAcceptCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your message has been successfully submitted to the trainer. Please await confirmation as the trainer reviews and accepts your request. Thank you for your patience!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitTrainerAcceptCompleted(false); DialogTrainerAcceptClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitStartDiscussionCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Time to kick off a conversation!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Begin the discussion with the trainer to explore and plan your training journey together.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitStartDiscussionCompleted(false); DialogStartDiscussionClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitTrainingScheduleCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Great news!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your training schedule has been formally submitted. Kindly communicate with the trainer and request confirmation through the portal. Thank you!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitTrainingScheduleCompleted(false); DialogTrainingScheduleClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitRemainderCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Great news!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Reminder sent successfully! Your gentle nudge has been delivered.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitRemainderCompleted(false); DialogProfileClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitPaymentCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your payment confirmation has been submitted to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitPaymentCompleted(false); DialogProfilePaymentCompletedClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitNewPaymentDateCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  New Payment date has been submitted to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitNewPaymentDateCompleted(false); DialogProfileNewPaymentDateClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitPaymentConfirmationCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your payment confirmation has been submitted to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitPaymentConfirmationCompleted(false); DialogProfilePaymentCompletedClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            {isModifyScheduleModalOpen && (
              <Modal open={isModifyScheduleModalOpen === true} onClose={() => { onModifyScheduleCancelClick(); }} sx={{ display: "grid", placeItems: "center" }}>
                <MKBox
                  position="relative"
                  width="580px"
                  display="flex"
                  flexDirection="column"
                  borderRadius="xl"
                  bgColor="white"
                  shadow="xl"
                >
                  <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                    Share Details to Schedule Training - {trainingDetails.trainingName}
                  </h2>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Training Start Date * :
                    </Typography>
                    <MKInput
                      type="date"
                      id="training_startDate"
                      style={{ marginLeft: '57px', width: '200px' }}
                      value={trainingStartDate || ""}
                      onChange={handleTrainingStartDateChange}
                      placeholder={trainingStartDate ? "" : "Training Start Date"}
                      inputProps={{ min: today }}
                      fullwidth
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Training End Date * :
                    </Typography>
                    <MKInput
                      type="date"
                      id="training_endDate"
                      style={{ marginLeft: '65px', width: '200px' }}
                      value={trainingEndDate || ""}
                      onChange={handleTrainingEndDateChange}
                      placeholder={trainingEndDate ? "" : "Training End Date"}
                      inputProps={{ min: today }}
                      fullwidth
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Expected Payment Date * :
                    </Typography>
                    <MKInput
                      type="date"
                      id="expected_paymentDate"
                      style={{ marginLeft: '20px', width: '200px' }}
                      value={expectedPaymentDate || ""}
                      onChange={handleExpectedPaymentDateChange}
                      placeholder={expectedPaymentDate ? "" : "Expected Payment Date"}
                      inputProps={{ min: today }}
                      fullwidth
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Finalized Training Hours * :
                    </Typography>
                    <FormControl variant="outlined">
                      <InputLabel style={{ marginLeft: '17px' }} id="Training Timing*">Per day</InputLabel>
                      <Select
                        labelId="TrainingTiming"
                        label="Per day"
                        fullWidth
                        onChange={handleFinalizedTrainingTimingChange}
                        value={finalizedTrainingTiming}
                        style={{ minHeight: '44px', marginLeft: '18px', width: '200px' }}
                      >
                        <MenuItem value="less than 4 hours">less than 4 hours</MenuItem>
                        <MenuItem value="4 hours">4 hours</MenuItem>
                        <MenuItem value="8 hours">8 hours</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Finalized Start Time * :
                    </Typography>
                    <TextField
                      label="Start Time"
                      type="time"
                      value={finalizedStartTime}
                      onChange={handleFinalizedStartTimeChange}
                      style={{ marginLeft: '48px', width: '200px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300,
                      }}
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Finalized End Time * :
                    </Typography>
                    <TextField
                      label="End Time"
                      type="time"
                      value={finalizedEndTime}
                      onChange={handleFinalizedEndTimeChange}
                      style={{ marginLeft: '56px', width: '200px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300,
                      }}
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Finalized Training Schedule *
                      <DatePicker
                        multiple
                        id="selectedDates"
                        style={{ marginLeft: '20px' }}
                        render={<CustomMultipleInput />}
                        onChange={handleFinalizedTrainingScheduleChange}
                        value={finalizedTrainingSchedule}
                        // minDate={new Date()}
                        // maxDate={fbmaxDate}
                        minDate={new Date(trainingStartDate)}
                        maxDate={new Date(trainingEndDate)}
                      />
                    </Typography>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    {Array.isArray(finalizedTrainingSchedule) && finalizedTrainingSchedule.length > 0 && (
                      <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                        <Typography style={{ fontSize: 'medium' }}>
                          Finalized Dates For Training:
                        </Typography>{' '}
                        {finalizedTrainingSchedule.join(', ')}
                      </Typography>
                    )}
                  </div>
                  <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                    <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Finalized Commericals (Total Cost for the Training)</span> }]} />
                  </Grid>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Grid item xs={12} md={4} style={{ marginTop: "20px", marginLeft: '10px' }}>
                      <div>
                        <FormControl variant="outlined" style={{ width: '200px' }}>
                          <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                          <Select
                            labelId="country-currency"
                            label="Country *"
                            fullWidth
                            onChange={handleCountryCurrencyChange}
                            value={selectedCurrencyCountry}
                            style={{ minHeight: '44px' }}
                          >
                            {getAllISOCodes().map((country) => (
                              <MenuItem key={country.iso} value={country.iso}>
                                {country.countryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4} style={{ marginTop: "20px", marginLeft: '10px' }}>
                      <div>
                        <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                          <span>Currency: {currency}</span>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4} style={{ marginTop: "20px" }}>
                      <div>
                        <TextField
                          label="Commericals *"
                          name="finalizedCommercials"
                          value={finalizedCommercials}
                          onChange={handleFinalizedCommercialsChange}
                          style={{ minHeight: '44px', width: '200px', marginLeft: '10px', borderColor: finalizedCommercialsError ? 'red' : undefined }}
                          error={finalizedCommercialsError}
                        />
                      </div>
                    </Grid>
                  </div>
                  {/* <div style={{ display: 'flex', alignItems: 'center',marginTop: '10px'  }}>
                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                  Finalized Commericals :
                </Typography>
                
              </div> */}
                  {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marignLeft: '10px',marginBottom: '10px',marginTop: '20px' }}>
                <MKButton variant="outlined" color="info" size="small"
                onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)}>Cancel</MKButton>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end',marignRight: '10px', marginBottom: '10px',marginTop: '-40px' }}>
                <MKButton variant="outlined" color="info" size="small" disabled={!trainingStartDate || !trainingEndDate || !expectedPaymentDate || !selectedCurrencyCountry || !currency || !finalizedCommercials ||
                  !finalizedStartTime || !finalizedEndTime || !finalizedTrainingSchedule || !finalizedTrainingTiming } 
                onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)} style={{ padding: '5px 10px' }}>Submit Schedule</MKButton>
              </div> */}
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '20px' }}>
                    <MKButton variant="gradient" color="info" size="small" onClick={() => { onModifyScheduleCancelClick(); }} style={{ padding: '5px 10px' }}>Cancel</MKButton>
                    <MKButton variant="gradient" color="info" size="small" disabled={!trainingStartDate || !trainingEndDate || !expectedPaymentDate || !selectedCurrencyCountry || !currency || !finalizedCommercials ||
                      !finalizedStartTime || !finalizedEndTime || !finalizedTrainingSchedule || !finalizedTrainingTiming || finalizedCommercialsError}
                      onClick={() => onSubmitModfiyScheduleClick()} style={{ marginLeft: '10px', padding: '5px 10px' }}>Submit Schedule</MKButton>
                  </div>
                </MKBox>
              </Modal>
            )}
            {trainerWithStatus6Modal && (
              <Modal open={trainerWithStatus6Modal} onClose={() => { setTrainerWithStatus6Modal(false); }} sx={{ display: "grid", placeItems: "center" }}>
                <MKBox
                  position="relative"
                  width="580px"
                  display="flex"
                  flexDirection="column"
                  borderRadius="xl"
                  bgColor="white"
                  shadow="xl"
                >
                  <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginTop: '10px' }}>
                    Notification !
                  </h2>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    <span>Today the training &nbsp;
                      <strong style={{ fontWeight: 'bold' }}>
                        {trainerWithStatus6.apply_training.selectedTrainingName}
                      </strong>&nbsp;
                      has to be started.
                    </span>
                  </Typography>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    Please click the "Start Training" button to initiate the training.
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '20px' }}>
                    <MKButton variant="gradient" color="info" size="small" onClick={() => onStartTrainingClick(trainerWithStatus6)} style={{ padding: '5px 10px' }}>Start Training</MKButton>
                  </div>
                </MKBox>
              </Modal>
            )}
            {trainerWithStatus9Modal && (
              <Modal open={trainerWithStatus9Modal} BackdropClick="ignore" sx={{ display: "grid", placeItems: "center" }}>
                <MKBox
                  position="relative"
                  width="580px"
                  display="flex"
                  flexDirection="column"
                  borderRadius="xl"
                  bgColor="white"
                  shadow="xl"
                >
                  <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginTop: '10px' }}>
                    Take the final step!
                  </h2>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    <span>Complete the Payment for the training &nbsp;
                      <strong style={{ fontWeight: 'bold' }}>
                        {trainerWithStatus9.apply_training.selectedTrainingName}
                      </strong>&nbsp;
                    </span>
                  </Typography>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    Please complete the payment and then click the "Payment Complete" button.
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}>
                    <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentCompletedClick(trainerWithStatus9)} style={{ padding: '5px 10px' }}>Payment Completed</MKButton>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                      In case of any issues, please reach us at support@labasservice.com
                    </Typography>
                  </div>
                </MKBox>
              </Modal>
            )}
            {trainerWithStatus7Modal && (
              <Modal open={trainerWithStatus7Modal} BackdropClick="ignore" sx={{ display: "grid", placeItems: "center" }}>
                <MKBox
                  position="relative"
                  width="580px"
                  display="flex"
                  flexDirection="column"
                  borderRadius="xl"
                  bgColor="white"
                  shadow="xl"
                >
                  <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginTop: '10px' }}>
                    Notification !
                  </h2>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    <span>The training &nbsp;
                      <strong style={{ fontWeight: 'bold' }}>
                        {trainerWithStatus7.apply_training.selectedTrainingName}
                      </strong>&nbsp;
                      is getting completed.
                    </span>
                  </Typography>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    Please click the "Training Complete" button to complete the training.
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}>
                    <MKButton variant="gradient" color="info" size="small" onClick={() => onTrainingCompletedClick(trainerWithStatus7)} style={{ padding: '5px 10px' }}>Training Completed</MKButton>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                      In case of any issues, please reach us at support@labasservice.com
                    </Typography>
                  </div>
                </MKBox>
              </Modal>
            )}
            {waitingTrainingConfirmation && (
              <Modal open={waitingTrainingConfirmation} sx={{ display: "grid", placeItems: "center" }}>
                <MKBox
                  position="relative"
                  width="580px"
                  display="flex"
                  flexDirection="column"
                  borderRadius="xl"
                  bgColor="white"
                  shadow="xl"
                >
                  <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                    Alert!
                  </h2>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                      Kindly await confirmation from Trainer - {trainerStatus20.firstName || trainerExceededPayment.firstName}&nbsp;{trainerStatus20.lastName || trainerExceededPayment.lastName} regarding your payment.
                    </Typography>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                      Access to Collab will be granted upon confirmation of payment by the trainer.
                    </Typography>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                      Thank you for your patience!
                    </Typography>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                      In case of any issues, please reach us at support@labasservice.com
                    </Typography>
                  </div>
                </MKBox>
              </Modal>
            )}
            {paymentNotReceivedModal && (
              <Modal open={paymentNotReceivedModal} BackdropClick="ignore" sx={{ display: "grid", placeItems: "center" }}>
                <MKBox
                  position="relative"
                  width="650px"
                  display="flex"
                  flexDirection="column"
                  borderRadius="xl"
                  bgColor="white"
                  shadow="xl"
                >
                  <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                    Attention !
                  </h2>
                  <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    It looks like the payment hasn't been received by the trainer - &nbsp;<strong>{trainerStatus12.firstName}&nbsp;{trainerStatus12.lastName}.</strong>
                  </MKTypography>
                  <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    Please review the transaction, and if there are any issues, reach out for assistance.
                  </MKTypography>
                  <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    Thank you for your attention to this matter.
                  </MKTypography>
                  <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    If the payment transaction is successfull , Please click on &nbsp;<strong>"Payment Completed"</strong>.
                  </MKTypography>
                  <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px', marginBottom: '10px', marginTop: "10px" }}>
                    <MKButton variant="gradient" color="info" size="small" disabled={expectedNewPaymentDate !== ""} onClick={() => onNewPaymentCompletedClick(trainerStatus12)} style={{ padding: '5px 10px' }}>Paymemt Completed</MKButton>
                  </div>
                  <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    If you wish to submit a new payment date, please click on
                  </MKTypography>
                  <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    <strong>"Submit New Payment Date"</strong>&nbsp; and select a date and proceed accordingly.
                  </MKTypography>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Expected New Payment Date * :
                    </Typography>
                    <MKInput
                      type="date"
                      id="expected_newPaymentDate"
                      style={{ marginLeft: '20px', width: '200px' }}
                      value={expectedNewPaymentDate || ""}
                      onChange={handleExpectedNewPaymentDateChange}
                      placeholder={expectedNewPaymentDate ? "" : "Expected New Payment Date"}
                      inputProps={{ min: today, max: maxDateString }}
                      fullwidth
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '10px' }}>
                    <MKButton variant="gradient" color="info" size="small" disabled={expectedNewPaymentDate === ""} onClick={() => onSubmitNewPaymentClick(trainerStatus12)} style={{ padding: '5px 10px' }}>Submit New Payment Date </MKButton>
                  </div>
                  <Typography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginBottom: '20px', marginTop: '10px' }}>
                    In case of any issues, please reach us at support@labasservice.com
                  </Typography>
                </MKBox>
              </Modal>
            )}

            <Modal open={paymentExceededModal} sx={{ display: "grid", placeItems: "center" }}>
              <MKBox
                position="relative"
                width="580px"
                display="flex"
                flexDirection="column"
                borderRadius="xl"
                bgColor="white"
                shadow="xl"
              >
                <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                  Take the final step!
                </h2>
                <Typography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                  Complete the Payment for the Training - {trainingDetails.trainingName}
                </Typography>
                <Typography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                  As this is final attempt, please upload payment proof
                </Typography>
                <Typography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                  Note : Payment Proof file should be in .jpeg /.jpg /.png /.pdf format with maximum size of 300kb
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                    Upload Payment Proof *
                  </Typography>
                  <input
                    type="file"
                    id="paymentProof-upload"
                    accept="pdf/*"
                    style={{ display: 'none' }}
                    ref={paymentProofFileInputRef}
                    onChange={handlePaymentProofUploadChange}
                  />

                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px', marginTop: '0px' }}>
                    <label htmlFor="resume-upload">
                      <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small">
                        Upload
                      </MKButton>
                    </label>
                    {paymentProof && (
                      <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                        <span>{paymentProof.name}</span>
                      </div>
                    )}
                  </div>
                </div>
                {error && (
                  <Typography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                    {error}
                  </Typography>
                )}
                <Typography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                  Please complete the payment and then click the "Payment Complete" button.
                </Typography>
                <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                  <MKButton variant="gradient" color="info" size="small" disabled={!fileUploaded || error} onClick={() => onFinalPaymentCompletedClick(trainerExceededPayment)} style={{ padding: '5px 10px' }}>
                    Payment Completed
                  </MKButton>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px', marginBottom: '10px' }}>
                    In case of any issues, please reach us at support@labasservice.com
                  </Typography>
                </div>
              </MKBox>
            </Modal>
            <MKBox component="section" py={{ xs: 6, sm: 12 }}>
              <Container>
                <Grid container item xs={12} justifyContent="center" mx="auto">
                  <Grid container justifyContent="center" py={6} style={{ marginTop: "-50px" }}>
                    <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                      {/* <MKTypography component="span" variant="body2" fontWeight="regular" color="text">
                Please review the details of the trainer who has applied for the training you posted, named '{selectedTrainingName}'. You can either select 'Accept' to proceed with this trainer or 'Decline' to reject their application.
              </MKTypography> */}
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={2}>
                        <Typography variant="h3">{trainingDetails.trainingName}</Typography>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Posted by :
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.trainingCompanyName}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={2}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Technology:
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.technology}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={2}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            <strong>Status:</strong>
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            <strong> {getTrainingStatusMessage(trainingDetails)} </strong>
                          </Typography>
                        </Grid>
                      </MKBox>

                      {trainingDetails.status === "Active" || trainingDetails.status <= 6 ? (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                            <Grid item xs={10.8}>
                              <Breadcrumbs
                                routes={[
                                  { label: <span style={{ fontWeight: 'bold' }}>Training Details</span> },
                                ]}
                              />
                            </Grid>
                            <Grid item>
                              <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleEditTrainingClick(trainingDetails)}>
                                Edit Training
                              </MKButton>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                          <Grid item xs={12}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Details</span> }]} />
                          </Grid>
                        </Grid>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Mode Of Training :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                            {trainingDetails.trainingMode}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Location :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                            {trainingDetails.trainingMode === "Virtual" ? "N/A" : trainingDetails.trainingLocations}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Time Zone :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainingDetails.timeZone}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Audience Level :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "65px" }}>
                            {trainingDetails.audienceLevel}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Training Expectation :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "27px" }}>
                            {trainingDetails.trainingExpectation}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Type :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                            {trainingDetails.trainingType}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Total Participants :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "47px" }}>
                            {trainingDetails.totalParticipants}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Total Training Budget :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "20px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.totalTrainingBudget}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Total Duration :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "45px" }}>
                            {trainingDetails.duration}&nbsp;hours
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Timing :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "63px" }}>
                            {trainingDetails.trainingTiming}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Start Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "99px" }}>
                            {trainingDetails.startTime}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "5px" }}>
                            End Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "75px" }}>
                            {trainingDetails.endTime}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Expected Start Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "34px" }}>
                            {trainingDetails.expectedStartDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Expected End Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "40px" }}>
                            {trainingDetails.deadline}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            TOC Available :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                            {trainingDetails.tocAvailable === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.tocAvailable === 'yes' && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick(trainingDetails)}>
                              Download Training Partner TOC
                            </MKButton>
                          </Grid>
                        </Grid>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Schedule :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "58px" }}>
                            {/* {trainingDetails.trainingSchedule} */}
                            {trainingDetails.trainingSchedule
                              ? trainingDetails.trainingSchedule
                                .replace(/'/g, "")
                                .replace(/\[|\]/g, "")
                                .split(", ")
                                .join(", ")
                              : ""}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.trainingScheduleComment && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={2}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Schedule Comments :&nbsp;
                            </Typography>
                          </Grid>
                          <Grid item xs={10}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                              {trainingDetails.trainingScheduleComment} <br />
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      {/* <Grid container spacing={4} mb={1}>
                <Grid item xs={12}>
                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{marginLeft : "15px"}}>
                    Requirements :&nbsp;
                  </Typography>
                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{marginLeft : "77px"}}>
                    {trainingDetails.requirements} <br />
                  </Typography>
                </Grid>
              </Grid> */}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Requirements :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainingDetails.requirements} <br />
                          </Typography>
                        </Grid>
                      </Grid>


                      {appliedTrainerDetails
                        .filter(trainer => {
                          const status = parseInt(trainer.apply_training.applyTrainingStatus);
                          return (status >= 5 && status <= 15) || ![1, 2, 3, 4, 16, 13, 14].includes(status);
                        }).length > 0 ? (
                        <>
                          {/* <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Finalized Training Details</span> }]} />
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={12} style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <MKButton variant="outlined" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick(trainingDetails)}>
                            Modify Schedule
                        </MKButton>
                      </Grid>
                    </Grid> */}

                          {/* <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                    <Grid item xs={12}>
                      <Breadcrumbs
                        routes={[
                          { label: <span style={{ fontWeight: 'bold' }}>Finalized Training Details</span> },
                          { label: <MKButton variant="outlined" color="info" size="small" style={{ marginLeft:"910px",padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick(trainingDetails)}>Modify Schedule</MKButton> }
                        ]}
                      />
                    </Grid>
                  </Grid> */}

                          {appliedTrainerDetails
                            .filter(trainer => {
                              const status = parseInt(trainer.apply_training.applyTrainingStatus);
                              return (status >= 5 && status <= 6);
                            }).length > 0 ? (
                            <>

                              <Grid container spacing={1} mb={1} style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                                <Grid item xs={10.5}>
                                  <Breadcrumbs
                                    routes={[
                                      { label: <span style={{ fontWeight: 'bold' }}>Finalized Training Details</span> },
                                    ]}
                                  />
                                </Grid>
                                <Grid item>
                                  <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleModifyScheduleTrainingClick(trainingDetails)}>
                                    Modify Schedule
                                  </MKButton>
                                </Grid>
                              </Grid>
                            </>
                          ) : (
                            <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                              <Grid item xs={12}>
                                <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Finalized Training Details</span> }]} />
                              </Grid>
                            </Grid>
                          )}



                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Training Start Date :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "44px" }}>
                                {trainingDetails.trainingStartDate}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Training End Date :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "54px" }}>
                                {trainingDetails.trainingEndDate}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Payment Date :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "82px" }}>
                                {trainingDetails.expectedPaymentDate3 !== null
                                  ? trainingDetails.expectedPaymentDate3
                                  : trainingDetails.expectedPaymentDate2 !== null
                                    ? trainingDetails.expectedPaymentDate2
                                    : trainingDetails.expectedPaymentDate1 !== null
                                      ? trainingDetails.expectedPaymentDate1
                                      : trainingDetails.expectedPaymentDate}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Training type :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "85px" }}>
                                {trainingDetails.finalizedTrainingHour}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Training Start Time :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "45px" }}>
                                {trainingDetails.finalizedStarttime}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Training End Time :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "54px" }}>
                                {trainingDetails.finalizedEndtime}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Finalized Commercials :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "80px" }}>
                                {trainingDetails.finalizedCommercialsCurrency}&nbsp;{trainingDetails.finalizedCommercials}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Finalized Training Schedule :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                                {trainingDetails.finalizedScheduledate
                                  ? trainingDetails.finalizedScheduledate
                                    .replace(/'/g, "")
                                    .replace(/\[|\]/g, "")
                                    .split(", ")
                                    .join(", ")
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        ""
                      )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Accepted Trainers</span> }]} />
                        </Grid>
                      </Grid>

                      {appliedTrainerDetails
                        .filter(trainer => {
                          const status = parseInt(trainer.apply_training.applyTrainingStatus);
                          return (status >= 3 && status <= 15) || [17, 18, 19].includes(status);
                        }).length === 0 ? (
                        <span style={{ marginLeft: "15px", marginBottom: "20px", fontSize: 'medium' }}>No trainers have been approved for this training so far.</span>
                      ) : (
                        <Grid container spacing={2} style={{ marginTop: "20px", marginLeft: "15px" }}>
                          {appliedTrainerDetails
                            .filter(trainer => {
                              const status = parseInt(trainer.apply_training.applyTrainingStatus);
                              return (status >= 3 && status <= 15) || [17, 18, 19].includes(status);
                            })
                            .map((trainer, index) => (
                              <Grid item xs={6} key={trainer.id} >
                                <div className="gridItemSeeMore">
                                  <div className="gridContentSeeMore">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <Typography variant="subtitle1" style={{ marginTop: '0px' }}>
                                          <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                        </Typography>
                                      </div>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> 
                                          {trainer.skills.length > 50 ? `${trainer.skills.substring(0, 50)}...` : trainer.skills}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                            <Rating
                                              name="read-only"
                                              value={trainer.trainerRating}
                                              precision={0.5}
                                              readOnly
                                            />
                                          </Stack>
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                          <strong style={{ marginLeft: '5px' }}> Status: {getStatusMessage(trainer)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>

                                    {parseInt(trainer.apply_training.applyTrainingStatus) === 3 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onStartDiscussionClick(trainer)} style={{ padding: '5px 10px' }}>Start Discussion</MKButton>
                                        </div>
                                      </>
                                    )}

                                    {parseInt(trainer.apply_training.applyTrainingStatus) === 4 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onScheduleTrainingClick(trainer)} style={{ padding: '5px 10px' }}>Schedule Training</MKButton>
                                        </div>
                                      </>
                                    )}

                                    {isModalOpen && (
                                      <Modal open={isModalOpen === true} onClose={() => { onScheduleCancelClick(); }} sx={{ display: "grid", placeItems: "center" }}>
                                        <MKBox
                                          position="relative"
                                          width="580px"
                                          display="flex"
                                          flexDirection="column"
                                          borderRadius="xl"
                                          bgColor="white"
                                          shadow="xl"
                                        >
                                          <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                                            Share Details to Schedule Training - {trainingDetails.trainingName}
                                          </h2>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Training Start Date * :
                                            </Typography>
                                            <MKInput
                                              type="date"
                                              id="training_startDate"
                                              style={{ marginLeft: '57px', width: '200px' }}
                                              value={trainingStartDate || ""}
                                              onChange={handleTrainingStartDateChange}
                                              placeholder={trainingStartDate ? "" : "Training Start Date"}
                                              inputProps={{ min: today }}
                                              fullwidth
                                            />
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Training End Date * :
                                            </Typography>
                                            <MKInput
                                              type="date"
                                              id="training_endDate"
                                              style={{ marginLeft: '65px', width: '200px' }}
                                              value={trainingEndDate || ""}
                                              onChange={handleTrainingEndDateChange}
                                              placeholder={trainingEndDate ? "" : "Training End Date"}
                                              inputProps={{ min: today }}
                                              fullwidth
                                            />
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Expected Payment Date * :
                                            </Typography>
                                            <MKInput
                                              type="date"
                                              id="expected_paymentDate"
                                              style={{ marginLeft: '20px', width: '200px' }}
                                              value={expectedPaymentDate || ""}
                                              onChange={handleExpectedPaymentDateChange}
                                              placeholder={expectedPaymentDate ? "" : "Expected Payment Date"}
                                              inputProps={{ min: today }}
                                              fullwidth
                                            />
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Finalized Training Hours * :
                                            </Typography>
                                            <FormControl variant="outlined">
                                              <InputLabel style={{ marginLeft: '17px' }} id="Training Timing*">Per day</InputLabel>
                                              <Select
                                                labelId="TrainingTiming"
                                                label="Per day"
                                                fullWidth
                                                onChange={handleFinalizedTrainingTimingChange}
                                                value={finalizedTrainingTiming}
                                                style={{ minHeight: '44px', marginLeft: '18px', width: '200px' }}
                                              >
                                                <MenuItem value="less than 4 hours">less than 4 hours</MenuItem>
                                                <MenuItem value="4 hours">4 hours</MenuItem>
                                                <MenuItem value="8 hours">8 hours</MenuItem>
                                              </Select>
                                            </FormControl>
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Finalized Start Time * :
                                            </Typography>
                                            <TextField
                                              label="Start Time"
                                              type="time"
                                              value={finalizedStartTime}
                                              onChange={handleFinalizedStartTimeChange}
                                              style={{ marginLeft: '48px', width: '200px' }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              inputProps={{
                                                step: 300,
                                              }}
                                            />
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Finalized End Time * :
                                            </Typography>
                                            <TextField
                                              label="End Time"
                                              type="time"
                                              value={finalizedEndTime}
                                              onChange={handleFinalizedEndTimeChange}
                                              style={{ marginLeft: '56px', width: '200px' }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              inputProps={{
                                                step: 300,
                                              }}
                                            />
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                              Finalized Training Schedule *
                                              <DatePicker
                                                multiple
                                                id="selectedDates"
                                                style={{ marginLeft: '20px' }}
                                                render={<CustomMultipleInput />}
                                                onChange={handleFinalizedTrainingScheduleChange}
                                                value={finalizedTrainingSchedule}
                                                // minDate={new Date()}
                                                // maxDate={fbmaxDate}
                                                minDate={new Date(trainingStartDate)}
                                                maxDate={new Date(trainingEndDate)}
                                              />
                                            </Typography>
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            {finalizedTrainingSchedule.length > 0 && (
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                <Typography style={{ fontSize: 'medium' }}>
                                                  Finalized Dates For Training:
                                                </Typography>{' '}
                                                {finalizedTrainingSchedule.join(', ')}
                                              </Typography>
                                            )}
                                          </div>
                                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Finalized Commericals (Total Cost for the Training)</span> }]} />
                                          </Grid>
                                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                            <Grid item xs={12} md={4} style={{ marginTop: "20px", marginLeft: '10px' }}>
                                              <div>
                                                <FormControl variant="outlined" style={{ width: '200px' }}>
                                                  <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                                                  <Select
                                                    labelId="country-currency"
                                                    label="Country *"
                                                    fullWidth
                                                    onChange={handleCountryCurrencyChange}
                                                    value={selectedCurrencyCountry}
                                                    style={{ minHeight: '44px' }}
                                                  >
                                                    {getAllISOCodes().map((country) => (
                                                      <MenuItem key={country.iso} value={country.iso}>
                                                        {country.countryName}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                </FormControl>
                                              </div>
                                            </Grid>
                                            <Grid item xs={12} md={4} style={{ marginTop: "20px", marginLeft: '20px' }}>
                                              <div>
                                                <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                                  <span>Currency: {currency}</span>
                                                </Typography>
                                              </div>
                                            </Grid>
                                            <Grid item xs={12} md={4} style={{ marginTop: "16px" }}>
                                              <div>
                                                <TextField
                                                  label="Commericals *"
                                                  name="finalizedCommercials"
                                                  value={finalizedCommercials}
                                                  onChange={handleFinalizedCommercialsChange}
                                                  style={{ minHeight: '44px', width: '200px', marginLeft: '-45px', borderColor: finalizedCommercialsError ? 'red' : undefined }}
                                                  error={finalizedCommercialsError}
                                                />
                                              </div>
                                            </Grid>
                                          </div>
                                          {/* <div style={{ display: 'flex', alignItems: 'center',marginTop: '10px'  }}>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  Finalized Commericals :
                                </Typography>
                                
                              </div> */}
                                          {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marignLeft: '10px',marginBottom: '10px',marginTop: '20px' }}>
                                <MKButton variant="outlined" color="info" size="small"
                                onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)}>Cancel</MKButton>
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'flex-end',marignRight: '10px', marginBottom: '10px',marginTop: '-40px' }}>
                                <MKButton variant="outlined" color="info" size="small" disabled={!trainingStartDate || !trainingEndDate || !expectedPaymentDate || !selectedCurrencyCountry || !currency || !finalizedCommercials ||
                                 !finalizedStartTime || !finalizedEndTime || !finalizedTrainingSchedule || !finalizedTrainingTiming } 
                                onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)} style={{ padding: '5px 10px' }}>Submit Schedule</MKButton>
                              </div> */}
                                          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '20px' }}>
                                            <MKButton variant="gradient" color="info" size="small" onClick={() => { onScheduleCancelClick(); }} style={{ padding: '5px 10px' }}>Cancel</MKButton>
                                            <MKButton variant="gradient" color="info" size="small" disabled={!trainingStartDate || !trainingEndDate || !expectedPaymentDate || !selectedCurrencyCountry || !currency || !finalizedCommercials ||
                                              !finalizedStartTime || !finalizedEndTime || !finalizedTrainingSchedule || !finalizedTrainingTiming || finalizedCommercialsError}
                                              onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)} style={{ marginLeft: '10px', padding: '5px 10px' }}>Submit Schedule</MKButton>
                                          </div>
                                        </MKBox>
                                      </Modal>
                                    )}

                                    {parseInt(trainer.apply_training.applyTrainingStatus) === 6 && (
                                      <>
                                        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onStartTrainingClick(trainer)} style={{ padding: '5px 10px' }}>Start Training</MKButton>
                              </div> */}
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          {new Date() >= new Date(trainingDetails.trainingStartDate) ? (
                                            <MKButton variant="gradient" color="info" size="small" onClick={() => onStartTrainingClick(trainer)} style={{ padding: '5px 10px' }}>
                                              Start Training
                                            </MKButton>
                                          ) : (
                                            <MKButton variant="gradient" color="dark" size="small" disabled style={{ padding: '5px 10px' }}>
                                              Start Training
                                            </MKButton>
                                          )}
                                        </div>
                                      </>
                                    )}

                                    {/* {parseInt(trainer.apply_training.applyTrainingStatus) === 7 && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onTrainingCompletedClick(trainer)} style={{ padding: '5px 10px' }}>Training Completed</MKButton>
                              </div>
                            </>
                          )} */}

                                    {parseInt(trainer.apply_training.applyTrainingStatus) === 7 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          {new Date(todayDate) >= new Date(trainingDetails.trainingEndDate) ? (
                                            <MKButton variant="gradient" color="info" size="small" onClick={() => onTrainingCompletedClick(trainer)} style={{ padding: '5px 10px' }}>
                                              Training Completed
                                            </MKButton>
                                          ) : (
                                            <MKButton variant="gradient" color="dark" size="small" disabled style={{ padding: '5px 10px' }}>
                                              Training Completed
                                            </MKButton>
                                          )}
                                        </div>
                                      </>
                                    )}

                                    {feedbackStatusAvailable && (
                                      <div>
                                        {/* {getFeedbackStatus(trainer)}                                */}
                                        <Modal open={feedbackStatusAvailable === true} onClose={() => setShowFeedbackModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                                          <MKBox
                                            position="relative"
                                            width="830px"
                                            display="flex"
                                            flexDirection="column"
                                            borderRadius="xl"
                                            bgColor="white"
                                            shadow="xl"
                                          >
                                            <div style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                                              <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                                                Feedback for the {trainingDetails.trainingName} Training for the Trainer - {trainer.firstName}&nbsp;{trainer.lastName}
                                              </h2>
                                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  Share your feedback by providing a rating for the trainer's performance * -
                                                </Typography>
                                                <Stack spacing={1} style={{ marginLeft: '20px', marginTop: '10px' }}>
                                                  <Rating
                                                    name="half-rating"
                                                    value={feedbackRating}
                                                    precision={0.5}
                                                    onChange={handleRatingChange}
                                                  />
                                                </Stack>
                                              </div>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[0].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer1.length >= 10 && feedbackAnswer1.length <= 500 && isFeedback1Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer1}
                                                    error={isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)}
                                                    helperText={
                                                      isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer1(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback1Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[1].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer2.length >= 10 && feedbackAnswer2.length <= 500 && isFeedback2Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer2}
                                                    fullWidth
                                                    error={isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)}
                                                    helperText={
                                                      isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer2(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback2Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[2].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer3.length >= 10 && feedbackAnswer3.length <= 500 && isFeedback3Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer3}
                                                    fullWidth
                                                    error={isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)}
                                                    helperText={
                                                      isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer3(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback3Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[3].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer4.length >= 10 && feedbackAnswer4.length <= 500 && isFeedback4Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer4}
                                                    fullWidth
                                                    error={isFeedback4Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)}
                                                    helperText={
                                                      isFeedback2Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer4(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback4Interacted(true)}
                                                  />
                                                </div>
                                              </Grid><Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[4].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer5.length >= 10 && feedbackAnswer5.length <= 500 && isFeedback5Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer5}
                                                    fullWidth
                                                    error={isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)}
                                                    helperText={
                                                      isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer5(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback5Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[5].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer6.length >= 10 && feedbackAnswer6.length <= 500 && isFeedback6Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer6}
                                                    fullWidth
                                                    error={isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)}
                                                    helperText={
                                                      isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer6(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback6Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[6].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer7.length >= 10 && feedbackAnswer7.length <= 500 && isFeedback7Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer7}
                                                    fullWidth
                                                    error={isFeedback7Interacted && (feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500)}
                                                    helperText={
                                                      isFeedback7Interacted && (feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer7(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback7Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                {feedbackQuestions.length > 0 && feedbackQuestions[7].question}
                                              </Typography>
                                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                <div>
                                                  <TextField
                                                    label="Min: 10 characters, Max: 500 characters"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    style={{
                                                      width: '650px', marginLeft: "20px",
                                                      borderColor: feedbackAnswer8.length >= 10 && feedbackAnswer8.length <= 500 && isFeedback8Interacted
                                                        ? "initial"
                                                        : "initial",
                                                    }}
                                                    value={feedbackAnswer8}
                                                    fullWidth
                                                    error={isFeedback8Interacted && (feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500)}
                                                    helperText={
                                                      isFeedback8Interacted && (feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500)
                                                        ? ""
                                                        : ""
                                                    }
                                                    onChange={(e) => {
                                                      setFeedbackAnswer8(e.target.value);
                                                    }}
                                                    onFocus={() => setIsFeedback8Interacted(true)}
                                                  />
                                                </div>
                                              </Grid>
                                              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                                <MKButton variant="gradient" color="info" size="small" disabled={!feedbackRating || !feedbackAnswer1 || feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500
                                                  || !feedbackAnswer2 || feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500
                                                  || !feedbackAnswer3 || feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500
                                                  || !feedbackAnswer4 || feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500
                                                  || !feedbackAnswer5 || feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500
                                                  || !feedbackAnswer6 || feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500
                                                  || !feedbackAnswer7 || feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500
                                                  || !feedbackAnswer8 || feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500}
                                                  onClick={() => onSubmitFeebackClick(trainer)} style={{ padding: '5px 10px' }}>Submit Feedback</MKButton>
                                              </div>
                                            </div>
                                          </MKBox>
                                        </Modal>
                                      </div>
                                    )}

                                    {[9, 17, 18, 19].includes(parseInt(trainer.apply_training.applyTrainingStatus)) && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentCompletedClick(trainer)} style={{ padding: '5px 10px' }}>
                                            Payment Completed
                                          </MKButton>
                                        </div>
                                      </>
                                    )}

                                    {/* {parseInt(trainer.apply_training.applyTrainingStatus) === 12 && (
                            <>
                              {getPaymentStatus(trainer)}
                            </> 
                          )}

                          {paymentNotReceivedModal && (
                              <>     
                              <div>                                                          
                              <Modal open={paymentNotReceivedModal === true && parseInt(trainer.apply_training.applyTrainingStatus) === 12 } onClose={() => setPaymentNotReceivedModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                                <MKBox
                                  position="relative"
                                  width="580px"
                                  display="flex"
                                  flexDirection="column"
                                  borderRadius="xl"
                                  bgColor="white"
                                  shadow="xl"
                                >
                                  <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                                    Sumbit new Payment date for the Trainer - {trainer.firstName}&nbsp;{trainer.lastName}
                                  </h2>  
                                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                      New Expected Payment Date * :
                                    </Typography>
                                    <MKInput
                                      type="date"
                                      id="expected_newPaymentDate"
                                      style={{ marginLeft: '20px', width: '200px' }}
                                      value={expectedNewPaymentDate || ""}
                                      onChange={handleExpectedNewPaymentDateChange}
                                      placeholder={expectedNewPaymentDate ? "" : "Expected New Payment Date"}
                                      inputProps={{ min: today, max: maxDateString }}
                                      fullwidth
                                    />
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                    <MKButton variant="outlined" color="info" size="small" onClick={() => onSubmitNewPaymentClick(trainer)} style={{ padding: '5px 10px' }}>Submit</MKButton>
                                  </div>
                                </MKBox>
                              </Modal>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onPaymentCompletedClick(trainer)} style={{ padding: '5px 10px' }}>Paymemt Completed</MKButton>
                              </div>
                              </div>
                            </>
                          )} */}

                                    {/* {getStatusMessage(trainer) === "Awaiting For your response" && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onAgreeClick(trainer)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                              </div>
                            </>
                          )}
                          {getStatusMessage(trainer) === "Company - Accepted. Awaiting for Trainer's response" && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onRemainderClick(trainer)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>                                
                              </div>
                            </>
                          )} */}
                                    {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onMoreDetails(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onApplyClick(trainer)} style={{ padding: '5px 10px' }}>Connect</MKButton>
                          </div> */}
                                  </div>
                                </div>
                              </Grid>
                            ))}
                          {appliedTrainerDetails
                            .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 5 || parseInt(trainer.apply_training.applyTrainingStatus) === 6)
                            .map((trainer, index) => (
                              <Grid key={index} style={{ justifyContent: 'flex-end' }}>
                                <MKButton
                                  variant="gradient"
                                  color="info"
                                  size="small"
                                  onClick={() => onResetClick()}
                                  style={{ padding: '5px 10px' }}
                                >
                                  Reset
                                </MKButton>
                              </Grid>
                            ))}
                          {appliedTrainerDetails
                            .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 7)
                            .map((trainer, index) => (
                              <Grid key={index} style={{ justifyContent: 'flex-end' }}>
                                <MKButton
                                  variant="gradient"
                                  color="info"
                                  size="small"
                                  onClick={() => onTrainingStartedResetClick()}
                                  style={{ padding: '5px 10px' }}
                                >
                                  Reset
                                </MKButton>
                              </Grid>
                            ))}
                        </Grid>
                      )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Applied Trainers</span> }]} />
                        </Grid>
                      </Grid>

                      {appliedTrainerDetails
                        .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 1 || parseInt(trainer.apply_training.applyTrainingStatus) === 2).length === 0 ? (
                        <span style={{ marginLeft: "15px", marginBottom: "20px", fontSize: 'medium' }}>No trainers have submitted their application for this training yet.</span>
                      ) : (
                        <Grid container spacing={2} style={{ marginTop: "20px", marginLeft: "15px" }}>
                          {appliedTrainerDetails
                            .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 1 || parseInt(trainer.apply_training.applyTrainingStatus) === 2)
                            .map((trainer, index) => (
                              <Grid item xs={6} key={trainer.id} >
                                <div className="gridItemSeeMore">
                                  <div className="gridContentSeeMore">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <Typography variant="subtitle1" style={{ marginTop: '0px' }}>
                                          <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                        </Typography>
                                      </div>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                          {trainer.skills.length > 50 ? `${trainer.skills.substring(0, 50)}...` : trainer.skills}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                            <Rating
                                              name="read-only"
                                              value={trainer.trainerRating}
                                              precision={0.5}
                                              readOnly
                                            />
                                          </Stack>
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                          <strong style={{ marginLeft: '5px' }}> Status: {getStatusMessage(trainer)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    {parseInt(trainer.apply_training.applyTrainingStatus) === 1 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onAgreeClick(trainer)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                                        </div>
                                      </>
                                    )}
                                    {parseInt(trainer.apply_training.applyTrainingStatus) === 2 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onRemainderClick(trainer)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>
                                        </div>
                                      </>
                                    )}
                                    {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onMoreDetails(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onApplyClick(trainer)} style={{ padding: '5px 10px' }}>Connect</MKButton>
                          </div> */}
                                  </div>
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Declined Trainers</span> }]} />
                        </Grid>
                      </Grid>

                      {appliedTrainerDetails
                        .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 13 || parseInt(trainer.apply_training.applyTrainingStatus) === 14).length === 0 ? (
                        <span style={{ marginLeft: "15px", marginBottom: "20px", fontSize: 'medium' }}>No trainers has been declined for this training so far.</span>
                      ) : (
                        <Grid container spacing={2} style={{ marginTop: "20px", marginLeft: "15px" }}>
                          {appliedTrainerDetails
                            .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 13 || parseInt(trainer.apply_training.applyTrainingStatus) === 14)
                            .map((trainer, index) => (
                              <Grid item xs={8} key={trainer.id} >
                                <div className="gridItemSeeMore">
                                  <div className="gridContentSeeMore">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <Typography variant="subtitle1" style={{ marginTop: '0px' }}>
                                          <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                        </Typography>
                                      </div>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                          {trainer.skills.length > 50 ? `${trainer.skills.substring(0, 50)}...` : trainer.skills}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                            <Rating
                                              name="read-only"
                                              value={trainer.trainerRating}
                                              precision={0.5}
                                              readOnly
                                            />
                                          </Stack>
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                          <strong style={{ marginLeft: '5px' }}> Status: {getStatusMessage(trainer)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    {/* {getStatusMessage(trainer) === "Awaiting For your response" && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onAgreeClick(trainer)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                              </div>
                            </>
                          )}
                          {getStatusMessage(trainer) === "Company - Accepted. Awaiting for Trainer's response" && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onRemainderClick(trainer)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>                                
                              </div>
                            </>
                          )} */}
                                    {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onMoreDetails(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onApplyClick(trainer)} style={{ padding: '5px 10px' }}>Connect</MKButton>
                          </div> */}
                                  </div>
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Vanquished Trainers</span> }]} />
                        </Grid>
                      </Grid>

                      {appliedTrainerDetails
                        .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 16).length === 0 ? (
                        <span style={{ marginLeft: "15px", marginBottom: "20px", fontSize: 'medium' }}>No trainers has been declined for this training so far.</span>
                      ) : (
                        <Grid container spacing={2} style={{ marginTop: "20px", marginLeft: "15px" }}>
                          {appliedTrainerDetails
                            .filter(trainer => parseInt(trainer.apply_training.applyTrainingStatus) === 16)
                            .map((trainer, index) => (
                              <Grid item xs={6} key={trainer.id} >
                                <div className="gridItemSeeMore">
                                  <div className="gridContentSeeMore">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <Typography variant="subtitle1" style={{ marginTop: '0px' }}>
                                          <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                        </Typography>
                                      </div>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> 
                                          {trainer.skills.length > 50 ? `${trainer.skills.substring(0, 50)}...` : trainer.skills}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                            <Rating
                                              name="read-only"
                                              value={trainer.trainerRating}
                                              precision={0.5}
                                              readOnly
                                            />
                                          </Stack>
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                          <strong style={{ marginLeft: '5px' }}> Status: {getStatusMessage(trainer)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    {/* {getStatusMessage(trainer) === "Awaiting For your response" && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onAgreeClick(trainer)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                              </div>
                            </>
                          )}
                          {getStatusMessage(trainer) === "Company - Accepted. Awaiting for Trainer's response" && (
                            <>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                <MKButton variant="outlined" color="info" size="small" onClick={() => onRemainderClick(trainer)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>                                
                              </div>
                            </>
                          )} */}
                                    {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onMoreDetails(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                              <MKButton variant="outlined" color="info" size="small" onClick={() => onApplyClick(trainer)} style={{ padding: '5px 10px' }}>Connect</MKButton>
                          </div> */}
                                  </div>
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      )}

                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onCancelClick()}
                        style={{ padding: '5px 10px' }}
                      >
                        Back
                      </MKButton>
                    </Grid>
                    {(parseInt(trainingDetails.status) === 6 || parseInt(trainingDetails.status) === 7 || trainingDetails.status === 'Active') && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onCancelTrainingClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Cancel Training
                          </MKButton>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Container>

            </MKBox>
            {/* <Posts /> */}
          </Card>
          {/* <Contact /> */}
          {/* <Footer /> */}
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
              <SimpleFooter />
            </MKBox>
          </div>
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default Author;
